import lf from 'lovefield'

export function exo_cubatures_exo_mouvements (schemaBuilder) {
  schemaBuilder.createTable('exo_cubatures_exo_mouvements')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('exo_cubatures_id', lf.Type.INTEGER)
      .addColumn('exo_mouvements_id', lf.Type.INTEGER)
      .addColumn('sens_inverse', lf.Type.INTEGER)
      .addColumn('ordre', lf.Type.INTEGER)

      .addPrimaryKey(['id'])
      // .addIndex('exoCubatures_id_3', ['exoMouvements_id']);
      // .addIndex('exoCubatures_id_4', ['exoMouvements_id']);
      // .addIndex('exoCubatures_id', ['exoCubatures_id', 'exoMouvements_id']);
      // .addIndex('exoCubatures_id_2', ['exoCubatures_id', 'exoMouvements_id']);


}

/*
CREATE TABLE IF NOT EXISTS `exo-cubatures_exo-mouvements` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `exo-cubatures_id` int(11) NOT NULL,
  `exo-mouvements_id` int(11) NOT NULL,
  `ordre` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  KEY `exo-cubatures_id_3` (`exo-mouvements_id`),
  KEY `exo-cubatures_id_4` (`exo-mouvements_id`),
  KEY `exo-cubatures_id` (`exo-cubatures_id`,`exo-mouvements_id`),
  KEY `exo-cubatures_id_2` (`exo-cubatures_id`,`exo-mouvements_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/exoCubatures_exoMouvements.schema.js